/**
 *
 * Asynchronously loads the component for CustomerManagement
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CustomerManagement = lazyLoad(
  () => import('./index'),
  module => module.CustomerManagement,
);
